import React from 'react'
import { Box, Divider, InputLabel, Stack, TextField, Typography, styled } from '@mui/material';
import { eyeInjuryLeft, eyeInjuryRight, presenting_complaint_options, rednessLeftOptions, rednessRightOptions, reviewSystemOptions, sectionBPainLeft, sectionBPainRight, visionLossLeftOptions, visionLossRightOptions, visualDistLeft, visualDistRight } from './formOptions';
import SelectController from '../../../../components/SelectController/SelectController';
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import RadioButtonController, { CheckBoxLikeRadio } from '../../../../components/RadioButtonController/RadioButtonController';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../DiabeticForm';
import InputController from '../../../../components/InputController/InputController';

export const InputLabelStyled = styled(InputLabel)(({theme})=>({
    // flexBasis:"180px",
    minWidth: "60px",
     fontSize: "14px", color: theme.palette.black.main, overflow: "visible", fontWeight:"bold", whiteSpace: "wrap"
}))

export const InputLabelStyledNormal = styled(InputLabel)(({theme})=>({
     fontSize: "14px", color: theme.palette.primary.main
}))

const InputLableCustom = styled(InputLabel)(({theme})=>({
    color: theme.palette.black.main, fontWeight:"bold", overflow: "visible", minWidth: "50px", fontSize:"13px"
}))

export const ParentSelectBox = styled(Box)(({theme})=>({
    display: "flex", flexDirection: "column", gap: "0.8rem", alignItems: "center", width: "100%"
}))

const PresentingComplaintOptionsContainer = (props)=>{
    const {heading, name, options, children} = props;
    return (
      <>
        <Box sx={{ width:"100%", display: "flex", alignItems: "center", gap:"1rem", "& > label:first-of-type": { width: "15% !important"}}}>
          <CustomInputLable>{heading}</CustomInputLable>
          <Box sx={{display: "flex", flexDirection: "column", gap:"0.5rem", height:"80px", justifyContent: "space-evenly"}}>
            <CustomInputLable>L</CustomInputLable>
            <CustomInputLable>R</CustomInputLable>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap:"0.5rem", width: "100%" }}>
            {children}
          </Box>
        </Box>
      </>
    );
  };

const PresentingComplaintSection = (props) => {
    const { control, errors, getValues, setValue, watch } = props


    return (
        <>
            <ParentContainerSection  heading="Section B - Presenting Complaint">
            <InputContainer>
          <CustomInputLable required >Presenting Complaint</CustomInputLable>
          <RadioButtonController
            name="presenting_complaint"
            control={control}
            errors={errors}
            options={presenting_complaint_options}
            isRow
            isDisabled
          />
        </InputContainer>

            <Divider/>


                 <><InputContainer>
          <PresentingComplaintOptionsContainer heading="Redness">
            <CheckboxController
               name={"redness.left"}
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={rednessLeftOptions}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
            <CheckboxController
              name={"redness.right"}
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={rednessRightOptions}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
          </PresentingComplaintOptionsContainer>
        </InputContainer>
        <Divider/>
        <InputContainer>
          <PresentingComplaintOptionsContainer heading="Vision Loss">
            <CheckboxController
               name="visionLoss.left"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={visionLossLeftOptions}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
            <CheckboxController
               name="visionLoss.right"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={visionLossRightOptions}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
          </PresentingComplaintOptionsContainer>
        </InputContainer>
        <Divider/>
        <InputContainer>
          <PresentingComplaintOptionsContainer heading="Pain">
            <CheckboxController
                name="pain.left"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={sectionBPainLeft}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
            <CheckboxController
                  name="pain.right"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={sectionBPainRight}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
          </PresentingComplaintOptionsContainer>
        </InputContainer>
        <Divider/>
        <InputContainer>
          <PresentingComplaintOptionsContainer heading="Eye Injury">
            <CheckboxController
               name="eyeInjury.left"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={eyeInjuryLeft}
              isHorizantalPadding={true}
              size="small" />
            <CheckboxController
                name="eyeInjury.right"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={eyeInjuryRight}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
          </PresentingComplaintOptionsContainer>
        </InputContainer>
        <Divider/>
        <InputContainer>
          <PresentingComplaintOptionsContainer heading="Visual Disturbances">
            <CheckboxController
              name="visualDisturbances.left"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={visualDistLeft}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
            <CheckboxController
               name="visualDisturbances.right"
              isRow={true}
              isMultiCheckbox={true}
              control={control}
              errors={errors}
              options={visualDistRight}
              isHorizantalPadding={true}
              isDisabled
              size="small" />
          </PresentingComplaintOptionsContainer>
        </InputContainer></>


        <InputContainer >

<CustomInputLable>Other Complaints</CustomInputLable>
<InputController
  name="otherComplaints"
  control={control}
  errors={errors}
  comment
  fullWidth
  isDisabled
  size="small"
  
/>
</InputContainer>

    <CustomInputLable sx={{ marginBottom: "0.5rem"}}>Review of systems</CustomInputLable>
        <InputContainer sx={{ marginLeft: "4px !important" }}>
          <CheckboxController
             name="reviewSystem"
            isRow={true}
            isMultiCheckbox={true}
            control={control}
            errors={errors}
            options={reviewSystemOptions}
            isHorizantalPadding={true}
            isDisabled
            size="small"
          />
        </InputContainer>

                </ParentContainerSection>
        </>
    )
}

export default PresentingComplaintSection